<template>
  <div class="authentication-area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-7">
          <div class="authentication-form">
            <h2>Register</h2>

            <div v-if="error" class="alert alert-danger py-2 mb-3">{{ error }}</div>

            <form @submit.prevent="handleRegister">
              <div class="form-floating mb-4">
                <input
                  v-model="name"
                  type="text"
                  class="form-control"
                  id="floatingInput3"
                  placeholder="Name"
                  required
                />
                <label for="floatingInput3" class="floating">Name</label>
              </div>
              <div class="form-floating mb-4">
                <input
                  v-model="email"
                  type="email"
                  class="form-control"
                  id="floatingInput4"
                  placeholder="Email"
                  required
                />
                <label for="floatingInput4" class="floating">Email</label>
              </div>
              <div class="form-floating mb-4">
                <input
                  v-model="phone"
                  type="tel"
                  class="form-control"
                  id="floatingInputPhone"
                  placeholder="Phone Number"
                />
                <label for="floatingInputPhone" class="floating">Phone Number (optional)</label>
              </div>
              <div class="form-floating mb-4">
                <input
                  v-model="password"
                  type="password"
                  class="form-control"
                  id="floatingInput5"
                  placeholder="Password"
                  minlength="8"
                  required
                />
                <label for="floatingInput5" class="floating">Password</label>
              </div>
              <div class="form-check mb-4">
                <input
                  v-model="agreed"
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheckDefault2"
                  required
                />
                <label class="form-check-label position-relative tops-2" for="flexCheckDefault2">
                  I accept all terms & conditions
                </label>
              </div>
              <div class="text-center">
                <button type="submit" class="btn px-275" :disabled="loading">
                  <span class="border-style">
                    {{ loading ? "Creating account..." : "Register Now" }}
                  </span>
                </button>
              </div>
              <div class="py-4 text-center">
                Already have an account?
                <RouterLink to="/login" class="text-white fw-bold">Login</RouterLink>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/store/auth";
import { useRecaptcha } from "@/composables/useRecaptcha";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Register",
  setup() {
    const name = ref("");
    const email = ref("");
    const phone = ref("");
    const password = ref("");
    const agreed = ref(false);
    const error = ref("");
    const loading = ref(false);
    const router = useRouter();
    const route = useRoute();
    const authStore = useAuthStore();
    const { getToken } = useRecaptcha();

    // Referral code from the invite link (?ref=CODE)
    const referralCode = (route.query.ref as string) || "";

    async function handleRegister() {
      error.value = "";
      loading.value = true;
      try {
        const recaptchaToken = await getToken("register");
        await authStore.register(name.value, email.value, password.value, recaptchaToken, phone.value, referralCode);
        router.push("/dashboard");
      } catch (e: any) {
        error.value = e?.response?.data?.message || "Registration failed. Please try again.";
      } finally {
        loading.value = false;
      }
    }

    return { name, email, phone, password, agreed, error, loading, handleRegister };
  },
});
</script>
